import SummaryCell from './Cell.js';
import FooterRow from './Row.js';

/**
 * Syntactic sugar. Do not support HOC.
 */
function Summary(_ref) {
  var children = _ref.children;
  return children;
}
Summary.Row = FooterRow;
Summary.Cell = SummaryCell;
export { Summary as default };
//# sourceMappingURL=Summary.js.map
